import { GetterTree } from 'vuex'
import {PartnerItem, PartnersState} from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<PartnersState, RootState> = {
    partners:state => state.partners,
    partnerItem:state => state.partnerItem,
    getPartnerById: (state) => (id: number) => {
        return state.partners.find((item:PartnerItem) => item.id === id);
    }
};
